import { ComponentType } from 'react';

import { AccessInformation, Checkout, Home, Login, Product, Products } from 'views/pages';

export type Route = {
    path: string;
    component: ComponentType<any>;
    exact?: boolean;
    routes?: Route[];
};

// TODO PB Try to refactor this definition and remove path namespace.
const routes = [
    {
        path: '/',
        component: Home,
        exact: false,
    },
    {
        path: '/products/:slug',
        component: Product,
    },
    {
        path: '/products',
        component: Products,
    },
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/access-information',
        component: AccessInformation,
    },
    {
        path: '/checkout',
        component: Checkout.Main,
        exact: false,
        routes: [
            {
                path: '/checkout/cart',
                component: Checkout.Cart,
            },
            {
                path: '/checkout/order',
                component: Checkout.Order,
            },
            {
                path: '/checkout/summary',
                component: Checkout.Summary,
            },
            {
                path: '/checkout/confirm',
                component: Checkout.Confirm,
            },
        ],
    },
];

export default routes;
